import { render, staticRenderFns } from "./BlockRemove.vue?vue&type=template&id=4ff7368b"
import script from "./BlockRemove.vue?vue&type=script&lang=js"
export * from "./BlockRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports